import React from "react";
import { MdDoDisturb } from "react-icons/md";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";

export default function NoPermissionThumbnail() {
  return (
    <Wrapper>
      <MdDoDisturb />
      <Text>No Permission</Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  width: 100%;
  padding-bottom: 56.25%;
  font-size: ${calcRem(40)};
  position: relative;
  background-color: ${COLORS.BLACK};
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${COLORS.WHITE}70;
  }
`;

const Text = styled.p`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${calcRem(16)};
  color: ${COLORS.WARNING};
`;
